var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scroll-view',{staticClass:"slide_box",attrs:{"scroll-y":""},on:{"touchstart":_vm.handleTouchStart,"touchend":_vm.handleTouchEnd}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }